
import { PersonalInfoFields } from "@/components/auth/registration/PersonalInfoFields"
import { EmailPasswordFields } from "@/components/auth/registration/EmailPasswordFields"
import { LocationFields } from "@/components/auth/registration/LocationFields"
import { RoleFields } from "@/components/auth/registration/RoleFields"
import { SubmitButton } from "@/components/auth/registration/SubmitButton"
import { UseFormReturn } from "react-hook-form"
import { RegistrationFormData } from "@/types/auth"

type RegistrationFormFieldsProps = {
  form: UseFormReturn<RegistrationFormData>
  loading: boolean
  adminCreating?: boolean
}

export function RegistrationFormFields({ 
  form, 
  loading,
  adminCreating = false
}: RegistrationFormFieldsProps) {
  return (
    <div className="space-y-6">
      <PersonalInfoFields form={form} />
      <EmailPasswordFields form={form} />
      <LocationFields form={form} />
      <RoleFields form={form} adminCreating={adminCreating} />
      <SubmitButton loading={loading} adminCreating={adminCreating} />
    </div>
  )
}
